import React from 'react';
import PropTypes from 'prop-types';
import * as utils from '../../utils/textUtil';
import { request } from '../../utils/request';

export default class UrlPreviews extends React.Component {
  state = {
    previews: []
  }

  componentDidMount() {
    const text = this.props.text;
    const previews = [];
    const previewUrls = utils.getUrls(text);

    previewUrls.forEach((url) => {
      request('/v2/noauth/unfurl?url=' + url).then((data) => {
        previews.push({
          url: url,
          icon: data.favicon,
          title: data.title,
          content: data.description,
          image: data.images && data.images[0] ? data.images[0].src : ''
        });
        this.setState({ previews });
      });
    });
  }

  render() {
    return (
      this.state.previews.map((preview, idx) => (
        <div key={idx} className="cu-ui-url-preview-container">
          <div className="head">
            <img className="icon" src={preview.icon} />
            <a href={preview.url} target="_blank">{preview.title}</a>
          </div>
          <p>{preview.content}</p>
          <img className="preview" src={preview.image} />
        </div>
      ))
    )
  }
}

UrlPreviews.propTypes = {
  text: PropTypes.string
};
